import React from 'react';
import ModalFrame from '../../ModalFrame';
import CreateOptions from './CreateOptions';

class CreateOptionsModalController extends React.Component {
  constructor(props) {
    super(props);
    this.hideModal = this.hideModal.bind(this);
  }

  hideModal() {
    const {setModalInfo} = this.props;
    setModalInfo({});
  }

  render() {
    const {modalInfo, confirmHandler, cancelHandler} = this.props;
    return (
      <div className="example-modal">
        {modalInfo.name === 'createOptions' ?
          <ModalFrame
            title="SCRIPT OPTIONS"
            desktopWidth="60%"
            headerCloseButtonHandler={this.hideModal}
            hasHeader={true}>
            <CreateOptions
              modalInfo={modalInfo}
              hideModal={this.hideModal}
              confirmHandler={confirmHandler}
              cancelHandler={cancelHandler}
            />
          </ModalFrame> : null}
      </div>
    )
  }
}

export default CreateOptionsModalController;
